
/* injects from baggage-loader */
require('./style.scss');

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { t } from "../../../../dev/helpers/translator";
import { connect } from 'react-redux';

const ExpressBonus = props => {
    const { bonuses, expBonus, posWin, stake } = props;
    const [tooltipOpened, setTooltipOpened] = useState(false);
    const tooltipContainer = useRef();

    const tooltipPosition = useMemo(() => {
        const { current } = tooltipContainer;

        return current ? {
            left: current.getBoundingClientRect().left,
            top: current.getBoundingClientRect().top
        } : {};
    }, [tooltipOpened]);

    const firstBonusBasis = bonuses[0].Basis;

    const bonus = useMemo(() => {
        if (!expBonus) return 0;

        const win = firstBonusBasis === 1 && stake && posWin
            ? posWin - stake
            : (posWin || 1);

        return Math.round((expBonus / win) * 100);
    }, [firstBonusBasis, expBonus, posWin, stake]);

    const closeTooltip = () => setTooltipOpened(false);

    const toggle = e => {
        e.stopPropagation();
        setTooltipOpened(!tooltipOpened);
    };

    return <div className="tooltip" ref={tooltipContainer}>
        <div className="infoIcon" onClick={toggle} />

        {(bonus || bonus === 0) && <span onClick={toggle}>
            &nbsp;{t("Bonus")}: <span className="bonusTextColor">{bonus}%</span>
        </span>}

        {tooltipOpened ? ReactDOM.createPortal(
            <div className="bonus-rule-tooltip-wrapper" onClick={closeTooltip}>
                <div className="tooltiptext bonus-rule-tooltip" style={tooltipPosition}>
                    <div className="tr">
                        <span>{t("Bonus")}</span>
                        <span>{t("Count")}</span>
                        <span>{t("Min odds")}</span>
                    </div>
                    {bonuses && bonuses.map((value, index) =>
                        <div className="td" key={index}>
                            <span>{value.AmountPercent + " %"}</span>
                            <span>{value.MaximumSelections === value.MinimumSelections ? value.MaximumSelections : value.MinimumSelections + " - " + (value.MaximumSelections ? value.MaximumSelections : t("and over"))}</span>
                            <span>{value.MinOdds}</span>
                        </div>
                    )}
                </div>
            </div>,
            document.querySelector('.terminal-wrapper')
        ) : null}
    </div>;
};

const mapStateToProps = (state) => {
    return {
        bonuses: state.terminal.bonuses
    };
};

export default connect(mapStateToProps)(ExpressBonus);
